module.exports = __webpack_public_path__ + "img/message-icon.3e0e74d7.svg";